const S3_BASE_URL = "https://hair-products-bucket.s3.eu-central-1.amazonaws.com";
export const getProductImage = (category, barcode, id) => {
    const key = barcode || id;
    return `${S3_BASE_URL}/${category}/${key}.jpeg`;
};

export const NOVA_GROUP_MAPPING = {
    "İşlenmemiş veya az işlenmiş gıdalar": "A",
    "İşlenmiş yemek malzemeleri": "B",
    "İşlenmiş gıdalar": "C",
    "Üst düzey işlemden geçmiş yiyecekler": "E",
};

export const NUTRIENT_TRANSLATIONS = {
    Fat: "Yağ",
    Salt: "Tuz",
    "Saturated fat": "Doymuş Yağ",
    Sugars: "Şeker"
};

export const POSITIVE_TRANSLATIONS = {
    fiber: {
        name: "Lif",
        description: "Lif bakımından zengin gıdaların (özellikle tam tahıllı gıdalar) tüketilmesi, sindirim sistemi kanserleri, kardiyovasküler hastalıklar, obezite ve diyabet riskini azaltır."
    },
    fruits_vegetables_legumes: {
        name: "Meyve, sebze ve baklagiller",
        description: "Meyve, sebze ve baklagiller açısından zengin gıdaların tüketilmesi, sindirim sistemi kanserleri, kalp-damar hastalıkları, obezite ve diyabet riskini azaltır."
    }
};

export const NEGATIVE_TRANSLATIONS = {
    energy: {
        name: "Enerji",
        description: "Enerji gereksinimlerinin üzerindeki enerji alımları, artan kilo alma, aşırı kilo, obezite ve dolayısıyla diyetle ilişkili kronik hastalık risklerinin artmasıyla ilişkilidir."
    },
    sugars: {
        name: "Şeker",
        description: "Yüksek şeker tüketimi kilo alımına ve diş çürümelerine neden olabilir. Aynı zamanda tip 2 diyabet ve kardiyovasküler hastalık riskini artırır."
    },
    saturated_fat: {
        name: "Doymuş Yağ",
        description: "Yüksek yağ tüketimi, özellikle doymuş yağlar, kalp hastalığı riskini artıran kolesterolü yükseltebilir."
    },
    salt: {
        name: "Tuz",
        description: "Yüksek miktarda tuz (veya sodyum) tüketimi, kalp hastalığı ve felç riskini artırabilen kan basıncının yükselmesine neden olabilir."
    }
};

export const NUTRI_SCORE_DESCRIPTIONS = {
    A: "çok iyi beslenme kalitesine sahiptir.",
    B: "iyi beslenme kalitesine sahiptir.",
    C: "orta düzeyde beslenme kalitesine sahiptir.",
    D: "düşük beslenme kalitesine sahiptir.",
    E: "çok kötü beslenme kalitesine sahiptir.",
};

export const TAG_ICONS = {
    halal: require("./icons/halal.png"),
    gluten: require("./icons/gluten.png"),
    lactose: require("./icons/lactose.png"),
    vegan: require("./icons/vegan.png"),
    vegetarian: require("./icons/vegetarian.png"),
    palm_oil: require("./icons/palm_oil.png"),
};

export const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A29BFE", "#E17055"];

export const NutrientIcons = {
    carbohydrates: require("./icons/carbohydrates.png"),
    proteins: require("./icons/protein.png"),
    fat: require("./icons/fat.png"),
    fiber: require("./icons/fiber.png"),
};

export const statusColors = {
    high: "#E57373",
    moderate: "#FFD54F",
    low: "#81C784",
    unknown: "#BDBDBD",
};

export const statusTranslations = {
    high: "Yüksek",
    moderate: "Orta",
    low: "Düşük",
    unknown: "Bilinmiyor",
};

export const defaultDailyIntake = {
    carbohydrates: 300,
    fat: 70,
    proteins: 50,
    fiber: 30,
};

export const ICON_COLORS = {
    anti_aging: { icon: "⏳", color: "#66BB6A" },
    anti_acne: { icon: "🩹", color: "#FF7043" },
    brightening: { icon: "💎", color: "#29B6F6" },
    moisturising: { icon: "💧", color: "#00C853" },
    uv_protection: { icon: "☀️", color: "#FFCA28" },
    wound_healing: { icon: "🩹", color: "#FF7043" },
    good_for_dry_skin: { icon: "🌵", color: "#4CAF50" },
    bad_for_dry_skin: { icon: "🌵", color: "#FF5252" },
    good_for_sensitive_skin: { icon: "🌿", color: "#4CAF50" },
    bad_for_sensitive_skin: { icon: "🌿", color: "#FF5252" },
    good_for_oily_skin: { icon: "💧", color: "#4CAF50" },
    bad_for_oily_skin: { icon: "💧", color: "#FF5252" },
    fungal_acne_trigger: { icon: "⚠️", color: "#FF7043" },
    allergens: { icon: "❗", color: "#FF5252" },
    silicone: { icon: "🔗", color: "#9E9E9E" },
    paraben: { icon: "🚫", color: "#9E9E9E" },
    sulfate: { icon: "💨", color: "#9E9E9E" },
};

export const FLAG_ICONS_COLORS = {
    paraben_free: { icon: "🧪", color: "#4CAF50" },
    sulfate_free: { icon: "🧴", color: "#FF9800" },
    silicone_free: { icon: "🧼", color: "#9C27B0" },
    fragrance_free: { icon: "🌼", color: "#FFB300" },
    alcohol_free: { icon: "💧", color: "#03A9F4" },
    salt_free: { icon: "🧂", color: "#795548" }
};

export const ALL_FLAGS = [
    "paraben_free",
    "sulfate_free",
    "silicone_free",
    "salt_free",
    "alcohol_free",
    "fragrance_free",
];

//dye_free: { icon: "🎨", color: "#607D8B" },
//allergen_free: { icon: "🌰", color: "#FF5722" },

export const FLAG_DESCRIPTIONS = {
    paraben_free: "Parabenler, ürünlerin raf ömrünü uzatmak için kullanılan kimyasallardır. Saç derisinde tahrişe neden olabilir ve uzun vadede hormonal dengeleri bozma riski taşır. Parabensiz ürünler, daha güvenli bir bakım sağlar.",
    sulfate_free: "Sülfatlar, şampuanın köpürmesini sağlayan maddedir. Ancak bu maddeler, doğal yağları da temizleyerek saçın kurumasına ve saç derisinin tahriş olmasına neden olabilir. Sülfatsız ürünler, hassas saç derisi ve kuru saçlar için daha uygundur.",
    silicone_free: "Silikonlar, saçı pürüzsüz ve parlak gösterir. Ancak uzun süreli kullanıldığında saçta birikim yaparak ağırlık ve cansızlık yaratabilir. Silikonsuz ürünler, saçın doğal nemini korumasına ve nefes almasına yardımcı olur.",
    fragrance_free: "Sentetik kokular, hassas saç derisinde alerjiye veya tahrişe yol açabilir. Parfümsüz ürünler, özellikle hassas ciltler ve saç derisi için daha güvenlidir.",
    dye_free: "Sentetik boyalar, saç derisinde tahrişe ve hassasiyete neden olabilir. Boyasız ürünler, saç derisi için daha doğal ve güvenli bir seçenek sunar.",
    alcohol_free: "Kurutucu alkoller saçın ve saç derisinin kurumasına neden olabilir. Alkolsüz ürünler, nemi koruyarak saçın daha sağlıklı kalmasına yardımcı olur.",
    salt_free: "Tuz, şampuanlarda kalınlaştırıcı olarak kullanılır. Ancak, fazla tuz saçın ve saç derisinin kurumasına neden olabilir. Tuzsuz ürünler, kuru veya hassas saç tipleri için daha uygundur."
};

export const FLAG_TRANSLATIONS = {
    paraben_free: "Paraben",
    sulfate_free: "Sülfat",
    silicone_free: "Silikon",
    salt_free: "Tuz",
    alcohol_free: "Alkol",
    fragrance_free: "Parfüm",
};
// dye_free: "Boya",

export const INGREDIENT_FLAG_TRANSLATIONS = {
    paraben: "Parabendir",
    sulfate: "Sülfattır",
    silicone: "Silikondur",
    fragrance: "Parfümdür",
    alcohol: "Alkoldür",
    salt: "Tuzdur",
};

// def contains_paraben(ingredient):
// return bool(re.search(r'-?paraben$', ingredient, re.IGNORECASE))

// def contains_sulfate(ingredient):
//     return bool(re.search(r'(sulfate|sulfonate)', ingredient, re.IGNORECASE))

// def contains_silicone(ingredient):
//     return bool(re.search(r'(silicone|dimethicone|xane|siloxane|methicone)', ingredient, re.IGNORECASE))

// def contains_fragrance(ingredient):
//     return bool(re.search(r'(fragrance|parfum|oil|extract|essential|linalool|limonene|citronellol|geraniol|eugenol|coumarin)', ingredient, re.IGNORECASE))

export const FLAG_INGREDIENTS_MAP = {
    paraben_free: [ // suffix -paraben as a reliable indicator
        "Methylparaben",
        "Ethylparaben",
        "Propylparaben",
        "Butylparaben",
        "Isobutylparaben",
        "Isopropylparaben",
        "Benzylparaben",
        "phenylparaben",
        "pentylparaben",
        "hexylparaben",
        "heptylparaben"
    ],
    sulfate_free: [ // Sulfates often contain the word "sulfate" or "sulfonate."
        "Sodium Lauryl Sulfate (SLS)",
        "Sodium Lauryl Sulfate",
        "sodium lauryl ether sulfate",
        "Sodium Laureth Sulfate",
        "Sodium Laureth Ether Sulfate",
        "Sodium Laureth Sulfate (SLES)",
        "Sodium Laureth Sulfate",
        "Ammonium Lauryl Sulfate",
        "Ammonium Laureth Sulfate",
        "Ammonium Sulfate",
        "Sodium Coco-Sulfate",
        "TEA-Lauryl Sulfate",
        "TEA Laureth Sulfate",
        "Magnesium Sulfate",
        "TEA-Dodecylbenzenesulfonate",
        "TEA-Sulfate",
        "teasulfate",
        "Sodium Xylenesulfonate",
        "Magnesium Lauryl Sulfate",
        "Magnesium Laureth Sulfate",
        "magnesiumlaureth sulfate",
        "Sodium Myreth Sulfate",
        "sodium cocosulfate",
        "sodium sulfate",
        "zinc sulfate"
    ],
    silicone_free: [
        "Dimethicone",
        "Cyclopentasiloxane",
        "Cyclohexasiloxane",
        "Phenyl Trimethicone",
        "Amodimethicone",
        "Dimethiconol",
        "Silicone Quaterniums",
        "Polysilicone-29",
        "polysilicone29",
        "Amodimethicone/Morpholinomethyl Silsesquioxane Copolymer",
        "Bis-Cetearyl Amodimethicone",
        "Trisiloxane",
        "silicone quaternium16",
        "silicone quaternium8",
        "Silicone Quaternium-8",
        "Silicone Quaternium-16",
        "silicone",
        "peg7 amodimethicone",
        "PEG-7 Amodimethicone"
    ],
    fragrance_free: [
        "Fragrance",
        "Parfum",
        "Fragrance (Parfum)",
        "Parfum (Fragrance)",
        "Essential Oils",
        "Synthetic Fragrances",
        "Linalool",
        "Citronellol",
        "Geraniol",
        "Eugenol",
        "Limonene",
        "Benzyl Salicylate",
        "Lilial",
        "Butylphenyl Methylpropional",
        "Coumarin",
        "Hydroxycitronellal",
        "Benzyl Alcohol",
        "Alpha-Isomethyl Ionone",
        "Hexyl Cinnamal",
        "Farnesol",
        "rose flower oil",
        "rose ketones",
        "Cananga Odorata Flower Oil",
        "Cananga Odorata Ylang Ylang Flower Oil",
        "Mentha Piperita Flower/Leaf/Stem Oil",
        "Mentha Piperita Leaf Extract",
        "Melissa Officinalis Leaf Extract",
        "Citrus Aurantium Dulcis Orange Peel Oil",
        "Citrus Limon Lemon Peel Oil",
        "Citrus Aurantium Orange Peel Oil"
    ],
    alcohol_free: [
        "Ethanol",
        "Isopropyl Alcohol",
        "SD Alcohol",
        "Benzyl Alcohol",
        "Methanol",
        "Denatured Alcohol",
        "Alcohol",
        "Phenoxyethanol"
    ],
    salt_free: [
        "Sodium Chloride",
        "Magnesium Sulfate",
        "Potassium Chloride",
        "Calcium Chloride",
        "Sea Salt (Maris Sal)",
        "Maris Sal",
        "Sea Salt",
        "Sodium Citrate",
        "Sodium Myristoyl Sarcosinate",
        "Sodium Thiosulfate",
        "Magnesium Carbonate Hydroxide",
        "Ammonium Chloride",
        "Disodium Phosphate",
        "Sodium Stearate",
        "Trisodium Phosphate",
        "Sodium Acetate",
        "Sodium Hydroxide",
        "Sodium Benzoate",
        "Sodium Cocoamphopropionate",
        "Tetrasodium EDTA",
        "Sodium PCA",
        "Magnesium Nitrate",
        "Sodium Bicarbonate",
        "Disodium EDTA"
    ]
};

// dye_free: [
//     "FD&C Red 40",
//     "FD&C Yellow 5",
//     "FD&C Blue 1",
//     "CI 42090",
//     "CI 14720",
//     "CI 75470",
//     "CI 19140"
// ],

export const COSMETIC_FUNCTION_TRANSLATIONS = {
    anti_aging: "Yaşlanma Karşıtı",
    anti_acne: "Sivilce Karşıtı",
    brightening: "Cilt Aydınlatıcı",
    moisturising: "Nemlendirici",
    uv_protection: "UV Koruması",
    wound_healing: "Yara İyileşmesini Destekler",
    good_for_dry_skin: "Kuru Ciltler İçin İyi",
    bad_for_dry_skin: "Kuru Ciltler İçin Kötü",
    good_for_sensitive_skin: "Hassas Ciltler İçin İyi",
    bad_for_sensitive_skin: "Hassas Ciltler İçin Kötü",
    good_for_oily_skin: "Yağlı Ciltler İçin İyi",
    bad_for_oily_skin: "Yağlı Ciltler İçin Kötü",
    fungal_acne_trigger: "Mantar Aknesi Tetikleyicisi",
    allergens: "Alerjen",
    silicone: "Silikon",
    paraben: "Paraben",
    sulfate: "Sülfat",
    comedogenic_rating_1: "Gözenek tıkama potansiyeli çok düşük (1)"
};

export const HAIR_FUNCTION_TRANSLATIONS = {
    // Moisturisers + Humectants + Emollients
    // Cooling Agents + Soothing
    // Thickeners + Viscosity Controlling Agents + Stabilisers + Gel-forming agents
    // Chelating + Antioxidants
    // Dyes + Colorants + Hair Dyes
    // Exfoliant + Detangling
    // Fragrance + Perfuming
    surfactants: { // Surfactants
        label: "Temizleyici",
        description: "Saçı ve saç derisini kir ve yağdan arındırır."
    },
    conditioning_agents: { // Haircare substances / Conditioning agents
        label: "Yumuşatıcı",
        description: "Saçı yumuşatır, kolay taranmasını sağlar."
    },
    humectants: { // Humectants, Moisturisers
        label: "Nem Tutucu",
        description: "Saçı nemlendirir ve kuruluğu önler."
    },
    preservative: { // Preservatives
        label: "Koruyucu",
        description: "Ürünün bozulmasını önler, raf ömrünü uzatır."
    },
    antioxidant: { // Antioxidants
        label: "Antioksidan",
        description: "Saçı serbest radikallerin zararlarına karşı korur."
    },
    chelating: {
        label: "Metal Tutucu",
        description: "Sert sudan kaynaklanan mineral birikimlerini önler."
    },
    uv_filters: { // Sunscreens/UV filters
        label: "Güneş Koruyucu",
        description: "Saçı güneşin zararlı etkilerinden korur."
    },
    emollients_and_oils: { // Refattening substances
        label: "Besleyici Yağlar",
        description: "Saçı besler, parlaklık ve yumuşaklık kazandırır."
    },
    thickeners_and_stabilizers: { //Stabilisers, Thickening agents / consistency regulators, Gel-forming agents
        label: "Kıvam Vericiler",
        description: "Ürünün dokusunu düzenler ve kıvamını ayarlar."
    },
    viscosity_controlling_agents: {
        label: "Kıvam Ayarlayıcı",
        description: "Ürünün yoğunluğunu ve kıvamını düzenler."
    },
    fragrance: { // Perfume / Fragrances
        label: "Koku",
        description: "Ürüne hoş bir koku verir."
    },
    ph_adjusters: { //Alkalising agents / Acids / Neutralising agents
        label: "pH Düzenleyici",
        description: "Saçın doğal pH dengesini korur."
    },
    proteins_and_amino_acids: { //Haircare substances / Conditioning agents
        label: "Proteinler ve Amino Asitler",
        description: "Saçı güçlendirir, onarır ve elastikiyet kazandırır."
    },
    anti_dandruff_agents: { //Anti-dandruff ingredients
        label: "Kepek Önleyici",
        description: "Kepeği azaltır, saç derisini yatıştırır."
    },
    colorant: { // Hair dyes, Dyes / Pigments
        label: "Renk Verici",
        description: "Saça renk verir veya ürünün rengini düzenler."
    },
    solvent: {
        label: "Çözücü",
        description: "Diğer bileşenlerin çözülmesine yardımcı olur."
    },
    soothing: { // Cooling agents
        label: "Yatıştırıcı",
        description: "Saç derisini rahatlatır ve tahrişi azaltır."
    },
    exfoliant: { // Detangling
        label: "Ölü Deri Temizleyici",
        description: "Saç derisindeki ölü hücreleri temizler."
    },

    anti_frizz_agents: {
        label: "Elektriklenme Önleyici",
        description: "Saçı pürüzsüzleştirir, kabarmayı ve elektriklenmeyi azaltır."
    },
    active_ingredients: {
        label: "Aktif Bileşenler",
        description: "Saçın sağlığını ve görünümünü iyileştiren etken maddeler."
    },
    miscellaneous_ingredients: {
        label: "Diğer Bileşenler",
        description: "Ürünün genel performansını destekleyen yardımcı maddeler."
    },
    herbal_extracts_and_botanicals: {
        label: "Bitkisel Özler",
        description: "Saç ve saç derisi sağlığı için doğal özler."
    },
    antimicrobial_and_antibacterial: {
        label: "Antimikrobiyal",
        description: "Saç derisini bakteri ve mikroplardan korur."
    },
    emulsifiers: {
        label: "Emülgatör",
        description: "Üründeki yağ ve suyun karışmasını sağlar."
    }
}

export const FUNCTION_TRANSLATIONS = {
    ph_regulator: "pH Düzenleyici", // "Asit-Baz Dengesi Sağlayıcı"
    antioxidant: "Antioksidan",
    soothing: "Yatıştırıcı", // "Tahrişi azaltır", "Kaşıntıyı hafifletir", "Serinletici"
    coloring: "Renklendirici",
    emulsifier: "Emülgatör",
    humectants: "Nemlendirici",
    fragrance: "Koku Verici",
    preservative: "Koruyucu",
    solvent: "Çözücü",
    cell_communicating: "Hücre Yenileyici",
    chelating: "Metal Tutucu",
    hair_softening: "Saç Yumuşatıcı",
    skin_softening: "Cilt Yumuşatıcı",
    viscosity_adjuster: "Kıvam Ayarlayıcı",
    cleansing_agent: "Temizleyici Madde",
    skin_preservative: "Cilt Koruyucu",
    exfoliant: "Ölü Deri Temizleyici"
};

export const INGREDIENTS_EXPLANATIONS = {
    Aqua: {
        localized_name: "Su",
        description: "Saf su, kozmetik formülasyonlarda çözücü olarak kullanılır.",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["solvent"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: [],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Sodium Laureth Sulfate": {
        description: "Temizleyici ve yüzey aktif madde; aşırı kullanımda ciltte kuruluğa neden olabilir.",
        score: 3,
        EWG: 3,
        CIR: "C",
        functions: ["surfactants"],
        cosmetic_functions: [],
        flags: ["sulfate"],
        labels: ["eczema_risk"],
        hair_type: ["bad_for_dry"],
        scalp_type: ["bad_for_dry"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Sodium Chloride": {
        description: "Kıvam artırıcı ve bağlayıcı olarak kullanılan tuz.",
        localized_name: "Tuz",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["thickeners_and_stabilizers"],
        cosmetic_functions: [],
        flags: ["salt"],
        labels: [],
        hair_type: ["bad_for_colored"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Cocamidopropyl Betaine": {
        description: "Nazik bir temizleyici ve yüzey aktif madde.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["surfactants"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: ["good_for_all"],
        scalp_type: [],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    Dimethiconol: {
        description: "Saçı pürüzsüzleştiren bir silikon türevi.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["conditioning_agents", "anti_frizz_agents"],
        cosmetic_functions: ["reduces_frizz", "adds_shine"],
        flags: ["silicone"],
        labels: [],
        hair_type: ["good_for_curly"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    Glycerin: {
        description: "Nem tutucu bir bileşen.",
        localized_name: "Gliserin",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["humectants"],
        cosmetic_functions: ["hydrating"],
        flags: [],
        labels: ["eczema_friendly"],
        hair_type: ["good_for_dry"],
        scalp_type: ["good_for_dry"],
        concerns: [],
        special_situations: []
    },
    Parfum: {
        description: "Koku verici bileşen, hassas ciltlerde tahrişe neden olabilir.",
        localized_name: "Parfüm",
        score: 4,
        EWG: 4,
        CIR: "D",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: ["bad_for_dry"],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Citric Acid": {
        description: "pH düzenleyici ve koruyucu.",
        localized_name: "Sitrik Asit",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["ph_adjusters"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: [],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Sodium Benzoate": {
        description: "Koruyucu ve antimikrobiyal madde.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["preservative"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: [],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    Carbomer: {
        description: "Kıvam artırıcı ve stabilizatör.",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["thickeners_and_stabilizers"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: [],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "TEA-Dodecylbenzenesulfonate": {
        description: "Etkili bir temizleyici ve yüzey aktif madde.",
        score: 3,
        EWG: 3,
        CIR: "C",
        functions: ["surfactants"],
        cosmetic_functions: [],
        flags: ["sulfate"],
        labels: [],
        hair_type: ["bad_for_dry"],
        scalp_type: ["bad_for_dry"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Guar Hydroxypropyltrimonium Chloride": {
        description: "Saçı yumuşatan ve taramayı kolaylaştıran bir madde.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["conditioning_agents"],
        cosmetic_functions: ["reduces_frizz"],
        flags: [],
        labels: [],
        hair_type: ["good_for_curly"],
        scalp_type: ["good_for_dry"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "TEA-Sulfate": {
        description: "Güçlü bir temizleyici yüzey aktif madde.",
        score: 3,
        EWG: 3,
        CIR: "C",
        functions: ["surfactants"],
        cosmetic_functions: [],
        flags: ["sulfate"],
        labels: [],
        hair_type: ["bad_for_dry"],
        scalp_type: ["bad_for_dry"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Hydroxypropyl Methylcellulose": {
        description: "Saçın nemini artıran ve parlaklık kazandıran bir madde.",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["conditioning_agents", "thickeners_and_stabilizers"],
        cosmetic_functions: ["reduces_frizz", "adds_shine"],
        flags: [],
        labels: [],
        hair_type: ["good_for_dry", "good_for_curly"],
        scalp_type: ["good_for_dry"],
        concerns: [],
        special_situations: []
    },
    Mica: {
        description: "Saça parlaklık veren bir mineral.",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["adds_shine"],
        cosmetic_functions: ["adds_shine"],
        flags: [],
        labels: [],
        hair_type: ["good_for_colored"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Disodium EDTA": {
        description: "Metal iyonlarını bağlayarak ürün stabilitesini artırır.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["chelating"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: [],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "PEG-45M": {
        description: "Saça yumuşaklık ve parlaklık kazandırır, kıvam artırıcıdır.",
        score: 3,
        EWG: 3,
        CIR: "C",
        functions: ["conditioning_agents", "thickeners_and_stabilizers"],
        cosmetic_functions: ["reduces_frizz", "adds_shine"],
        flags: [],
        labels: [],
        hair_type: ["good_for_dry", "good_for_curly"],
        scalp_type: ["good_for_dry"],
        concerns: [],
        special_situations: []
    },
    Phenoxyethanol: {
        description: "Koruyucu ve antimikrobiyal madde.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["preservative"],
        cosmetic_functions: [],
        flags: [],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Sodium Hydroxide": {
        description: "pH düzenleyici bir madde.",
        score: 3,
        EWG: 3,
        CIR: "C",
        functions: ["ph_adjusters"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: [],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "PPG-9": {
        description: "Saçı pürüzsüzleştiren ve parlaklık kazandıran bir madde.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["conditioning_agents"],
        cosmetic_functions: ["reduces_frizz", "adds_shine"],
        flags: [],
        labels: [],
        hair_type: ["good_for_dry", "good_for_curly"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Persea Gratissima (Avocado) Oil": {
        description: "Avokado yağı, saçı besler ve nemlendirir.",
        localized_name: "Avokado Yağı",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["emollients_and_oils"],
        cosmetic_functions: ["adds_shine"],
        flags: [],
        labels: [],
        hair_type: ["good_for_dry"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Vitis Vinifera (Grape) Seed Oil": {
        description: "Üzüm çekirdeği yağı, saçı besler ve parlaklık sağlar.",
        localized_name: "Üzüm Çekirdeği Yağı",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["emollients_and_oils"],
        cosmetic_functions: ["adds_shine"],
        flags: [],
        labels: [],
        hair_type: ["good_for_dry"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    Silica: {
        description: "Saçı matlaştırabilir ve fazla yağı emebilir.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["miscellaneous_ingredients"],
        cosmetic_functions: [],
        flags: [],
        labels: [],
        hair_type: ["good_for_oily"],
        scalp_type: ["good_for_oily"],
        concerns: [],
        special_situations: []
    },
    "Benzyl Alcohol": {
        description: "Koruyucu ve çözücü olarak kullanılır, hassas ciltlerde tahrişe neden olabilir.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["preservative", "solvent"],
        cosmetic_functions: [],
        flags: ["alcohol"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Benzyl Salicylate": {
        description: "Koku maddesi, hassas ciltlerde tahrişe neden olabilir.",
        score: 3,
        EWG: 3,
        CIR: "C",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    Citronellol: {
        description: "Doğal bir koku bileşeni, hassas ciltlerde tahrişe neden olabilir.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Hexyl Cinnamal": {
        description: "Koku bileşeni, hassas ciltlerde tahrişe neden olabilir.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    Limonene: {
        description: "Doğal bir koku bileşeni, hassas ciltlerde tahrişe neden olabilir.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    Linalool: {
        description: "Doğal bir koku bileşeni, hassas ciltlerde tahrişe neden olabilir.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["irritation_allergy"],
        special_situations: []
    },
    "Cl 77891": {
        description: "Titanyum dioksit, UV koruyucu ve beyazlatıcı bir bileşen.",
        score: 1,
        EWG: 1,
        CIR: "A",
        functions: ["uv_filters"],
        cosmetic_functions: ["uv_protection"],
        flags: [],
        labels: [],
        hair_type: ["good_for_colored"],
        scalp_type: [],
        concerns: [],
        special_situations: []
    },
    "Salicylic Acid": {
        description: "Ölü deri hücrelerini temizler ve kepek oluşumunu azaltır.",
        localized_name: "Salisilik Asit",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["exfoliant", "anti_dandruff_agents"],
        cosmetic_functions: ["anti_dandruff"],
        flags: [],
        labels: [],
        hair_type: ["good_for_oily"],
        scalp_type: ["good_for_oily"],
        concerns: [],
        special_situations: ["bad_for_pregnants"]
    },
    "Butylphenyl Methylpropional": {
        description: "Koku bileşeni, hassas ciltlerde tahrişe neden olabilir.",
        score: 4,
        EWG: 4,
        CIR: "C",
        functions: ["fragrance"],
        cosmetic_functions: [],
        flags: ["fragrance"],
        labels: ["eczema_risk"],
        hair_type: [],
        scalp_type: ["bad_for_sensitive"],
        concerns: ["hormone_disruption"],
        special_situations: ["bad_for_pregnants"]
    },
    "Zinc Pyrithione": {
        description: "Kepek karşıtı bir aktif madde.",
        score: 2,
        EWG: 2,
        CIR: "B",
        functions: ["anti_dandruff_agents"],
        cosmetic_functions: ["anti_dandruff"],
        flags: [],
        labels: ["eczema_friendly"],
        hair_type: ["good_for_oily"],
        scalp_type: ["good_for_oily"],
        concerns: [],
        special_situations: []
    }
};

// cruelty_free: "Hayvan Dostu",
// oil_free: "Yağsız",
// non_comedogenic: "Komedojenik Değil",
// vegan: "Vegan",
// gluten_free: "Glutensiz",
// hypoallergenic: "Hipoalerjenik",
// organic: "Organik",
// dermatologist_tested: "Dermatolog Onaylı",
// pregnancy_safe: "Hamileler İçin Uygun",
// mineral_oil_free: "Mineral Yağsız",
// formaldehyde_free: "Formaldehitsiz",
// uv_protection: "UV Koruma",
// biodegradable: "Biyolojik Olarak Çözünür",

export const capitalizeFirstWord = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const createEcoScoreDescription = (details) => {
    if (!details) return "Çevre skoru bilgisi bulunmamaktadır.";

    const { co2_total, co2_impact_level, packaging, threatened_species_impact } = details;

    const co2Info = co2_total && co2_impact_level
        ? (
            <div className="eco-row">
                <span className="eco-icon">🌍</span>
                <span>
                    <strong>Karbon Ayak İzi:</strong> {co2_total.toFixed(2)} kg CO₂
                    <span className="eco-impact"> ({capitalizeFirstWord(co2_impact_level)})</span>
                </span>
            </div>
        )
        : null;

    const packagingInfo = packaging && packaging.length > 0
        ? (
            <div className="eco-row">
                <span className="eco-icon">📦</span>
                <span>
                    <strong>Ambalaj:</strong> {packaging.map((item, index) =>
                        index === 0
                            ? capitalizeFirstWord(
                                item === "non_recyclable"
                                    ? "geri dönüştürülemez"
                                    : "biyolojik olarak parçalanamaz"
                            )
                            : item === "non_recyclable"
                                ? "geri dönüştürülemez"
                                : "biyolojik olarak parçalanamaz"
                    ).join(", ")}
                </span>
            </div>
        )
        : null;

    const speciesImpactInfo = threatened_species_impact
        ? (
            <div className="eco-row">
                <span className="eco-icon">🐾</span>
                <span>
                    <strong>Habitat Etkisi:</strong> {capitalizeFirstWord(threatened_species_impact)}
                </span>
            </div>
        )
        : null;

    return (
        <div className="processing-info fun-card">
            {co2Info}
            {packagingInfo}
            {speciesImpactInfo}
        </div>
    );
};

export const CHEMICALS = {
    "Cancer": [
        { "name": "DMDM Hydantoin", "risk": "High" },
        { "name": "Carbon Black", "risk": "High" },
        { "name": "Climbazole", "risk": "High" },
        { "name": "Cyclopentasiloxane", "risk": "High" },
        { "name": "Cyclotetrasiloxane", "risk": "High" },
        { "name": "BHT", "risk": "High" },
        { "name": "Cocamide DEA", "risk": "Moderate" },
    ],
    "Hormone_Disruption": [
        { "name": "Benzophenone-4", "risk": "High" },
        { "name": "Cyclopentasiloxane", "risk": "High" },
        { "name": "Cyclotetrasiloxane", "risk": "High" }
    ],
    "Irritation_Allergy": [
        { "name": "Sodium Lauryl Sulfate", "risk": "High" },
        { "name": "Sodium Laureth Sulfate", "risk": "Moderate" },
        { "name": "Phenoxyethanol", "risk": "Moderate" },
        { "name": "Hexylene Glycol", "risk": "Moderate" },
        { "name": "Parfum", "risk": "High" },
        { "name": "Chlorhexidine Digluconate", "risk": "Moderate" },
        { "name": "PEG-40", "risk": "Moderate" },
        { "name": "Ammonium Lauryl Sulfate", "risk": "Moderate" },
        { "name": "Cocamide DEA", "risk": "Moderate" },
        { "name": "Cocamidopropyl Betaine", "risk": "Low" },
        { "name": "Sodium Chloride", "risk": "Low" },
        { "name": "Citric Acid", "risk": "Low" },
        { "name": "BHT", "risk": "High" },
    ],
    "Pregnancy_Baby_Safety": [
        { "name": "Toluene", "risk": "High" },
        { "name": "Retinyl Palmitate", "risk": "High" },
        { "name": "Salicylic Acid", "risk": "Moderate" },
        { "name": "Hydroquinone", "risk": "High" },
        { "name": "Octinoxate", "risk": "High" },
        { "name": "Benzophenone-4", "risk": "Moderate" },
        { "name": "Phenoxyethanol", "risk": "Moderate" }
    ],
    "Rosacea_Triggers": [
        { "name": "Ethanol", "risk": "High" },
        { "name": "Alcohol Denat.", "risk": "High" },
        { "name": "Isopropyl Alcohol", "risk": "High" },
        { "name": "Parfum", "risk": "High" },
        { "name": "Mentha Piperita Oil", "risk": "High" },
        { "name": "Cinnamomum Zeylanicum Bark Oil", "risk": "High" },
        { "name": "Citrus Limon Peel Oil", "risk": "High" },
        { "name": "Hamamelis Virginiana Water", "risk": "Moderate" }
    ],
    "Eczema_Triggers": [
        { "name": "Sodium Lauryl Sulfate", "risk": "High" },
        { "name": "Phenoxyethanol", "risk": "High" },
        { "name": "Parfum", "risk": "High" },
        { "name": "Limonene", "risk": "Moderate" },
        { "name": "Lanolin Alcohol", "risk": "Moderate" }
    ],
    "Acne_Triggers": [
        { "name": "Cocos Nucifera Oil", "risk": "High" },
        { "name": "Theobroma Cacao Seed Butter", "risk": "High" },
        { "name": "Isopropyl Myristate", "risk": "High" },
        { "name": "Dimethicone", "risk": "Moderate" },
        { "name": "Petrolatum", "risk": "Moderate" }
    ],
    "Hyperpigmentation_Risks": [
        { "name": "Hydroquinone", "risk": "High" },
        { "name": "Citrus Limon Peel Oil", "risk": "High" },
        { "name": "Benzoyl Peroxide", "risk": "Moderate" }
    ],
    "Pregnancy_Safety": [
        { "name": "Retinol", "risk": "High" },
        { "name": "Tretinoin", "risk": "High" },
        { "name": "Retinyl Palmitate", "risk": "High" },
        { "name": "Adapalene", "risk": "High" },
        { "name": "Isotretinoin", "risk": "High" },
        { "name": "Hydroquinone", "risk": "High" },
        { "name": "Salicylic Acid", "risk": "Moderate" },
        { "name": "Oxybenzone", "risk": "Moderate" },
        { "name": "Rosemary Oil", "risk": "Moderate" },
        { "name": "Clary Sage Oil", "risk": "Moderate" },
        { "name": "Basil Oil", "risk": "Moderate" },
        { "name": "Cinnamon Oil", "risk": "Moderate" },
        { "name": "Juniper Oil", "risk": "Moderate" },
        { "name": "Wintergreen Oil", "risk": "Moderate" },
        { "name": "Thyme Oil", "risk": "Moderate" },
        { "name": "Oregano Oil", "risk": "Moderate" }
    ],
    "Barrier_Damage": [
        { "name": "Sodium Lauryl Sulfate", "risk": "High" },
        { "name": "Alcohol Denat.", "risk": "High" },
        { "name": "Benzoyl Peroxide", "risk": "Moderate" }
    ]
};

// "Banned_Chemicals": [
//         { "name": "Triclosan", "risk": "High" },
//         { "name": "Lilial (Butylphenyl Methylpropional)", "risk": "High" },
//         { "name": "Isopropylparaben", "risk": "High" },
//         { "name": "Isobutylparaben", "risk": "High" },
//         { "name": "Formaldehyde", "risk": "High" },
//         { "name": "Dibutyl Phthalate (DBP)", "risk": "High" },
//         { "name": "Benzene", "risk": "High" },
//         { "name": "Chloroform", "risk": "High" },
//         { "name": "Hexachlorophene", "risk": "High" }
//     ],


export const categoryTitles = {
    Cancer: "Kanser",
    Hormone_Disruption: "Hormon Bozukluğu",
    Pregnancy_Baby_Safety: "Gebelik ve Bebek Güvenliği",
    Irritation_Allergy: "Tahriş ve Alerji",
    Banned_Chemicals: "Yasaklı Kimyasallar",
    Rosacea_Triggers: "Kızarıklık ve Hassasiyet",
    Eczema_Triggers: "Egzama ve Kuruluk",
    Acne_Triggers: "Akne ve Sivilce",
    Hyperpigmentation_Risks: "Leke ve Renk Eşitsizliği",
    Pregnancy_Safety: "Gebelikte Riskli",
    Barrier_Damage: "Cilt Bariyeri Hasarı"
};

// chemical_load: [
//     { name: "PEG-150 Distearate", risk: "Moderate", note: "Synthetic thickener; may contain 1,4-Dioxane contaminants." },
//     { name: "Polysorbate 20", risk: "Moderate", note: "Synthetic emulsifier; may contain ethoxylation byproducts like 1,4-Dioxane." },
//     { name: "Polysorbate 80", risk: "Moderate", note: "Synthetic emulsifier; potential for contamination with 1,4-Dioxane." },
//     { name: "Phenoxyethanol", risk: "Moderate", note: "Synthetic preservative; potential skin sensitizer." },
//     { name: "Dimethicone", risk: "Low", note: "Silicone-based emollient; non-biodegradable." },
//     { name: "Polyquaternium-10", risk: "Low", note: "Synthetic conditioning agent; generally safe but contributes to chemical load." },
//     { name: "Acrylates Copolymer", risk: "Moderate", note: "Synthetic film-former; potential microplastic." },
//     { name: "Hydroxyethylcellulose", risk: "Low", note: "Cellulose derivative; biodegradable and generally safe." },
//     { name: "Cetrimonium Chloride", risk: "Moderate", note: "Quaternary ammonium compound; potential skin and eye irritant." },
//     { name: "Polyquaternium-7", risk: "Low", note: "Synthetic conditioning agent; generally safe but non-biodegradable." },
//     { name: "Polyquaternium-11", risk: "Low", note: "Synthetic film-former; non-biodegradable." },
//     { name: "Silicone Quaterniums", risk: "Moderate", note: "Silicone-based conditioning agents; persistent in the environment." },
//     { name: "Amodimethicone", risk: "Moderate", note: "Silicone-based conditioning agent; non-biodegradable but safe for use." }
// ]

export const getIconForCategory = (category) => {
    const icons = {
        Cancer: "🚩",
        Hormone_Disruption: "🧪",
        Pregnancy_Baby_Safety: "🤰",
        Irritation_Allergy: "🌡️",
        Banned_Chemicals: "❌",
        Hyperpigmentation_Risks: "🌞",
        Barrier_Damage: "🛡️",
        Pregnancy_Safety: "🍼",
        Rosacea_Triggers: "🔥",
        Eczema_Triggers: "🧴",
        Acne_Triggers: "🔴",
    };
    return icons[category] || "❓";
};

export const HAIR_AND_SCALP_TYPES = {
    hair: {
        dry_hair: {
            icon: "💧",
            label: "Kuru Saç",
        },
        oily_hair: {
            icon: "💦",
            label: "Yağlı Saç",
        },
        colored_hair: {
            icon: "🎨",
            label: "Boyalı Saç",
        },
        curly_hair: {
            icon: "✨",
            label: "Kıvırcık Saç",
        },
    },
    scalp: {
        dry_scalp: {
            icon: "🌵",
            label: "Kuru Saç Derisi",
        },
        oily_scalp: {
            icon: "🧴",
            label: "Yağlı Saç Derisi",
        },
        sensitive_scalp: {
            icon: "🍃",
            label: "Hassas Saç Derisi",
        },
    },
};

export const SKIN_TYPES = {
    skin: {
        dry_skin: {
            icon: "🌵",
            label: "Kuru Cilt",
        },
        oily_skin: {
            icon: "💦",
            label: "Yağlı Cilt",
        },
        combination_skin: {
            icon: "🌦️",
            label: "Karma Cilt",
        },
        sensitive_skin: {
            icon: "🍃",
            label: "Hassas Cilt",
        },
        normal_skin: {
            icon: "🌿",
            label: "Normal Cilt",
        },
    },
    concerns: {
        acne_prone: {
            icon: "🩹",
            label: "Akne Eğilimli",
        },
        redness: {
            icon: "🌸",
            label: "Kızarıklık",
        },
        hyperpigmentation: {
            icon: "🌞",
            label: "Leke Problemi",
        },
        aging: {
            icon: "⏳",
            label: "Yaşlanma Belirtileri",
        },
    },
};

export const OVERALL_TO_STATUS = {
    "Recommended": "suitable",
    "Mixed": "partially_suitable",
    "Not Recommended": "not_suitable"
};

export const getStatusIcon = (status) => {
    switch (status) {
        case "suitable":
            return "🥰";
        case "partially_suitable":
            return "🫤";
        case "not_suitable":
            return "😖";
        default:
            return "😶";
    }
};

export const HAIR_TYPES = {
    hair: [
        {
            key: "dry_hair",
            icon: "💧",
            label: "Kuru Saç",
            good: [
                "Glycerin",
                "Aloe Barbadensis Leaf Juice",
                "Cocos Nucifera Oil",
                "Argania Spinosa Kernel Oil",
                "Sodium Hyaluronate",
                "Panthenol",
                "Allantoin",
                "Hydrolyzed Keratin",
                "Hydrolyzed Silk",
                "Hydrolyzed Wheat Protein"
            ],
            bad: [
                "Sodium Lauryl Sulfate",
                "Sodium Laureth Sulfate",
                "Isopropyl Alcohol",
                "Methylparaben",
                "Parfum",
                "Guar Hydroxypropyltrimonium Chloride",
                "Hydroxypropyl Methylcellulose",
                "PEG-45M"
            ]
        },
        {
            key: "oily_hair",
            icon: "💦",
            label: "Yağlı Saç",
            good: [
                "Salicylic Acid",
                "Charcoal Powder",
                "Acetic Acid",
                "Silica",
                "Menthol",
                "Zinc PCA"
            ],
            bad: [
                "Dimethicone",
                "Cetearyl Alcohol",
                "Propylene Glycol",
                "Cyclopentasiloxane"
            ]
        },
        {
            key: "colored_hair",
            icon: "🎨",
            label: "Boyalı Saç",
            good: [
                "Hydrolyzed Keratin",
                "Tocopheryl Acetate",
                "Argania Spinosa Kernel Oil",
                "Mica",
                "Hydrolyzed Pearl"
            ],
            bad: [
                "Sodium Chloride",
                "Alcohol Denat",
                "Ammonium Lauryl Sulfate"
            ]
        },
        {
            key: "curly_hair",
            icon: "✨",
            label: "Kıvırcık Saç",
            good: [
                "Cocos Nucifera Oil",
                "Aloe Barbadensis Leaf Juice",
                "Hydrolyzed Keratin",
                "Hydrolyzed Wheat Protein",
                "Hydrolyzed Corn Protein"
            ],
            bad: [
                "Cyclopentasiloxane",
                "Sodium Lauryl Sulfate",
                "Methylparaben",
            ]
        }
    ],
    scalp: [
        {
            key: "dry_scalp",
            icon: "🌵",
            label: "Kuru Saç Derisi",
            good: [
                "Aloe Barbadensis Leaf Juice",
                "Sodium PCA",
                "Panthenol",
                "Sodium Hyaluronate",
                "Allantoin",
                "Bisabolol",
                "Chamomilla Recutita Flower Extract"
            ],
            bad: [
                "Sodium Lauryl Sulfate",
                "Sodium Laureth Sulfate",
                "Isopropyl Alcohol",
                "Methylparaben",
                "Fragrance"
            ]
        },
        {
            key: "oily_scalp",
            icon: "🫇",
            label: "Yağlı Saç Derisi",
            good: [
                "Melaleuca Alternifolia Tea Tree Oil",
                "Charcoal Powder",
                "Acetic Acid",
                "Menthol",
                "Silica",
                "Zinc Pyrithione",
                "Salicylic Acid"
            ],
            bad: [
                "Dimethicone",
                "Isopropyl Alcohol",
                "Alcohol Denat"
            ]
        },
        {
            key: "sensitive_scalp",
            icon: "🍃",
            label: "Hassas Saç Derisi",
            good: [
                "Chamomilla Recutita Flower Extract",
                "Avena Sativa Oat Kernel Extract",
                "Aloe Barbadensis Leaf Juice",
                "Allantoin",
                "Bisabolol",
                "Zinc Pyrithione",
                "Calendula Officinalis Flower Extract"
            ],
            bad: [
                "Methylisothiazolinone",
                "Fragrance",
                "DMDM Hydantoin",
                "Alcohol Denat"
            ]
        }
    ]
};

export const evaluateHairType = (ingredients = [], typeGroup, typeKey) => {
    const hairTypeGroup = HAIR_TYPES[typeGroup];
    if (!hairTypeGroup) return { status: "unknown", good: [], bad: [] };

    const hairTypeData = hairTypeGroup.find((type) => type.key === typeKey);
    if (!hairTypeData) return { status: "unknown", good: [], bad: [] };

    const { good = [], bad = [] } = hairTypeData;

    const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, "");

    const matchedGood = [];
    const matchedBad = [];

    ingredients.forEach((ingredient) => {
        const normalizedIngredient = normalize(ingredient);

        const goodMatch = good.find(({ name, variations = [] }) => {
            return (
                normalize(name) === normalizedIngredient ||
                variations.some((variation) => normalize(variation) === normalizedIngredient)
            );
        });

        if (goodMatch) matchedGood.push(goodMatch.name);

        const badMatch = bad.find(({ name, variations = [] }) => {
            return (
                normalize(name) === normalizedIngredient ||
                variations.some((variation) => normalize(variation) === normalizedIngredient)
            );
        });

        if (badMatch) matchedBad.push(badMatch.name);
    });

    if (matchedGood.length && !matchedBad.length) {
        return { status: "suitable", good: matchedGood, bad: [] };
    }

    if (matchedBad.length && !matchedGood.length) {
        return { status: "not_suitable", good: [], bad: matchedBad };
    }

    if (matchedGood.length && matchedBad.length) {
        return { status: "partially_suitable", good: matchedGood, bad: matchedBad };
    }

    return { status: "unknown", good: [], bad: [] };
};

export const hairScalpLabels = {
    hair_type: {
        good_for_dry: "Kuru saçlar için uygun",
        bad_for_dry: "Kuru saçlar için uygun değil",
        good_for_oily: "Yağlı saçlar için uygun",
        bad_for_oily: "Yağlı saçlar için uygun değil",
        good_for_colored: "Boyalı saçlar için uygun",
        bad_for_colored: "Boyalı saçlar için uygun değil",
        good_for_curly: "Kıvırcık saçlar için uygun",
        bad_for_curly: "Kıvırcık saçlar için uygun değil",
    },
    scalp_type: {
        good_for_dry: "Kuru deri için uygun",
        bad_for_dry: "Kuru deri için uygun değil",
        good_for_oily: "Yağlı deri için uygun",
        bad_for_oily: "Yağlı deri için uygun değil",
        good_for_sensitive: "Hassas deri için uygun",
        bad_for_sensitive: "Hassas deri için uygun değil",
    }
};

export const hairTypeNames = {
    dry_hair: "Kuru Saç",
    oily_hair: "Yağlı Saç",
    colored_hair: "Boyalı Saç",
    curly_hair: "Kıvırcık Saç",
};

export const scalpTypeNames = {
    dry_scalp: "Kuru Deri",
    oily_scalp: "Yağlı Deri",
    sensitive_scalp: "Hassas Deri",
};

export const skinTypeNames = {
    dry_skin: "Kuru Cilt",
    oily_skin: "Yağlı Cilt",
    combination_skin: "Karma Cilt",
    sensitive_skin: "Hassas Cilt",
    normal_skin: "Normal Cilt",
};

export function getHairIcon(hairTypeKey) {
    if (hairTypeKey.includes("dry")) return "💧";
    if (hairTypeKey.includes("oily")) return "💦";
    if (hairTypeKey.includes("colored")) return "🎨";
    if (hairTypeKey.includes("curly")) return "✨";
    return "";
}

export function getScalpIcon(type) {
    if (type.includes("dry")) return "🌵";
    if (type.includes("oily")) return "🫧";
    if (type.includes("sensitive")) return "🍃";
    return "";
}

export const ANTI_DANDRUFF_AGENTS = {
    high_effectiveness: [
        "Ketoconazole",
        "Zinc Pyrithione",
        "Selenium Sulfide",
        "Ciclopirox Olamine"
    ],
    moderate_effectiveness: [
        "Piroctone Olamine (Octopirox)",
        "Climbazole",
        "Coal Tar"
    ],
    mild_effectiveness: [
        "Salicylic Acid",
        "Sulfur",
        "Ichthyol (Sodium Shale Oil Sulfonate)",
        "Tea Tree Oil"
    ]
};

export const notableEffects = [
    {
        key: "hydration_and_moisture",
        label: "Saçı Nemlendirir, Kuruluğu Giderir",
        icon: "💧",
        description: "Saç kuruluğunu giderir, nem dengesini sağlar ve saç derisini rahatlatır.",
        primaryFunctions: ["MOISTURISING", "HUMECTANT"],
        supportingFunctions: ["SOOTHING", "SKIN CONDITIONING", "REFATTING", "ANTI-SEBUM", "ASTRINGENT"]
    },
    {
        key: "strengthening_and_repairing",
        label: "Saçı Güçlendirir, Dökülmeyi Azaltır",
        icon: "💪",
        description: "Zayıflamış saçları güçlendirir, kırılmaları azaltır ve dökülmeye karşı korur.",
        primaryFunctions: ["HAIR CONDITIONING", "BINDING", "SKIN PROTECTING"],
        supportingFunctions: ["FILM FORMING", "HAIR FIXING"]
    },
    {
        key: "scalp_care",
        label: "Kepeği Azaltır, Kaşıntıyı Hafifletir",
        icon: "🪷",
        description: "Kepek oluşumunu önler, saç derisini yatıştırır ve kaşıntıyı azaltır.",
        primaryFunctions: ["ANTI-SEBORRHEIC", "ANTIMICROBIAL", "KERATOLYTIC"],
        supportingFunctions: ["SOOTHING", "SKIN CONDITIONING", "ASTRINGENT", "ANTI-SEBUM"]
    },
    {
        key: "frizz_control_and_manageability",
        label: "Kabarmayı Azaltır, Kolay Şekil Verir",
        icon: "🌊",
        description: "Saç kabarmasını kontrol altına alır ve kolay şekil almasını sağlar.",
        primaryFunctions: ["SMOOTHING", "SKIN CONDITIONING - EMOLLIENT"],
        supportingFunctions: ["HAIR CONDITIONING", "SOOTHING"]
    },
    {
        key: "shine_and_appearance",
        label: "Saça Parlaklık, Güzel Görünüm Katar",
        icon: "✨",
        description: "Saça parlaklık katar, daha sağlıklı ve bakımlı görünmesini sağlar.",
        primaryFunctions: ["OPACIFYING"],
        supportingFunctions: ["REFRESHING", "HAIR CONDITIONING"]
    },
    {
        key: "uv_and_environmental_protection",
        label: "Saçı Güneş ve Çevresel Faktörlerden Korur",
        icon: "☀️",
        description: "Saçı UV ışınlarına ve çevresel zararlara karşı korur.",
        primaryFunctions: ["UV ABSORBER", "UV FILTER"],
        supportingFunctions: []
    }
];

export const skinNotableEffects = [
    {
        key: "Deep Cleansing & Sebum Control",
        label: "Derin Temizlik",
        icon: "🧼",
        description: "Cildi derinlemesine temizler, fazla yağı ve kiri arındırır."
    },
    {
        key: "Exfoliation & Pore Refining",
        label: "Gözenek Arındırma",
        icon: "🛁",
        description: "Ölü deriyi temizler, cilt dokusunu yeniler ve gözenekleri sıkılaştırır."
    },
    {
        key: "Hydration & Skin Conditioning",
        label: "Yoğun Nem",
        icon: "💧",
        description: "Cildi nemlendirir, kuruluğu giderir ve bariyeri güçlendirir."
    },
    {
        key: "Acne Prevention & Antimicrobial Care",
        label: "Sivilce Önleyici",
        icon: "🦠",
        description: "Sivilce oluşumunu engeller, bakterilerle savaşır ve cildi yatıştırır."
    },
    {
        key: "pH Balancing & Refreshing Effects",
        label: "pH Dengeleyici",
        icon: "🌿",
        description: "Cildin pH seviyesini dengeler, ferahlatır ve tahrişi yatıştırır."
    },
    {
        key: "Hydration & Barrier",
        label: "Cilt Nemlendirme Koruma",
        icon: "🛡️",
        description: "Cildi yoğun nemlendirir ve koruyucu bariyeri güçlendirir."
    },
    {
        key: "Anti-Aging & Renewal",
        label: "Yaşlanma Karşıtı",
        icon: "⏳",
        description: "Kırışıklıkları azaltır, cildi yeniler ve sıkılığını artırır."
    },
    {
        key: "Brightening & Even Tone",
        label: "Cilt Aydınlatma",
        icon: "✨",
        description: "Cilt tonunu eşitler, koyu lekeleri azaltır ve ışıltı kazandırır."
    },
    {
        key: "Soothing & Redness",
        label: "Kızarıklık Azaltıcı",
        icon: "🌸",
        description: "Cildi sakinleştirir, tahrişi ve kızarıklığı azaltır."
    },
    {
        key: "Oil Control & Mattifying",
        label: "Yağ Dengesi",
        icon: "🧴",
        description: "Fazla yağı dengeler, parlama ve yağlanmayı önler."
    },
    {
        key: "Anti-Aging and Fine Line Reduction",
        label: "Kırışıklık Azaltıcı",
        icon: "🕰️",
        description: "İnce çizgileri azaltır, cildi sıkılaştırır ve gençleştirir."
    },
    {
        key: "Dark Circle Reduction and Brightening",
        label: "Göz Altı Aydınlatma",
        icon: "🌙",
        description: "Göz altı morluklarını azaltır ve daha aydınlık bir görünüm sağlar."
    },
    {
        key: "Soothing and De-Puffing",
        label: "Şişkinlik Giderici",
        icon: "🥒",
        description: "Göz çevresindeki şişkinliği azaltır ve rahatlatıcı bir etki sağlar."
    },
    {
        key: "UV Protection and Damage Prevention",
        label: "Göz Çevresi Güneş Koruması",
        icon: "🕶️",
        description: "Göz çevresini güneşin zararlı ışınlarından korur."
    },
    {
        key: "Antioxidant Defense and Environmental Protection",
        label: "Dış Etken Koruyucu",
        icon: "🛑",
        description: "Cildi çevresel etkilere ve serbest radikallere karşı korur."
    },
    {
        key: "Brightening and Radiance Boosting",
        label: "Cilt Parlaklık Artırıcı",
        icon: "💡",
        description: "Cilde ışıltı kazandırır ve daha canlı bir görünüm sağlar."
    },
    {
        key: "Deep Nourishment and Repair",
        label: "Yoğun Besleyici",
        icon: "🥑",
        description: "Cildi besler, derinlemesine onarır ve sağlıklı bir görünüm kazandırır."
    },
    {
        key: "Protection and Environmental Defense",
        label: "Dudak Koruması",
        icon: "🛑",
        description: "Cildi dış etkenlerden korur ve bariyeri güçlendirir."
    },
    {
        key: "Soothing and Post-Exfoliation Care",
        label: "Cilt Yatıştırıcı",
        icon: "🌿",
        description: "Peeling sonrası cildi yatıştırır ve rahatlatır."
    },
    {
        key: "Texture Improvement and Skin Renewal",
        label: "Cilt Dokusunu İyileştirme",
        icon: "🧖‍♀️",
        description: "Cildin dokusunu pürüzsüzleştirir ve yenilenmesini destekler."
    },
    {
        key: "Hydration and Moisture Retention",
        label: "Yoğun Nem Tutma",
        icon: "💦",
        description: "Cildin nemi hapsetmesini sağlar ve uzun süreli nemlendirme sunar."
    },
    {
        key: "Repair, Soothing, and Healing",
        label: "Onarım ve Yatıştırıcı",
        icon: "🌱",
        description: "Cildi yeniler, onarır ve yatıştırıcı etki sağlar."
    },
    {
        key: "Skin Renewal and Anti-Aging",
        label: "Cilt Yenileyici",
        icon: "🌀",
        description: "Cildi yeniler ve yaşlanma belirtilerini azaltır."
    },
    {
        key: "Firming and Smoothing",
        label: "Sıkılaştırıcı ve Pürüzsüzleştirici",
        icon: "💆",
        description: "Cildi sıkılaştırır, pürüzsüz ve genç bir görünüm kazandırır."
    },
    {
        key: "Deep Cleansing and Pore Refining",
        label: "Gözenek Temizleyici",
        icon: "🛀",
        description: "Gözenekleri derinlemesine temizler ve fazla yağı giderir."
    },
    {
        key: "Brightening and Even Tone",
        label: "Cilt Tonu Dengeleyici",
        icon: "🌟",
        description: "Cilt tonunu eşitler, koyu lekeleri azaltır ve sağlıklı bir görünüm kazandırır."
    },
    {
        key: "Soothing and Calming",
        label: "Cilt Yatıştırıcı",
        icon: "🍃",
        description: "Cildi yatıştırır, tahrişi azaltır ve rahatlatıcı bir etki sağlar."
    },
    {
        key: "Skin Renewal and Exfoliation",
        label: "Cilt Yenileyici",
        icon: "🔄",
        description: "Ölü derileri temizleyerek cildi yeniler ve tazeler."
    },
    {
        key: "Pore Tightening and Sebum Control",
        label: "Gözenek Sıkılaştırıcı",
        icon: "🎯",
        description: "Gözenekleri sıkılaştırır ve yağ dengesini kontrol altına alır."
    },
    {
        key: "Hydration and Skin Conditioning",
        label: "Derin Nemlendirme",
        icon: "💦",
        description: "Cildi derinlemesine nemlendirir ve besleyici etki sağlar."
    },
    {
        key: "Exfoliation and Skin Renewal",
        label: "Cilt Arındırma",
        icon: "🌀",
        description: "Ölü deriyi temizler ve cildi yenileyerek pürüzsüz hale getirir."
    },
    {
        key: "Oil Control and Deep Nourishment",
        label: "Yağ Dengesi ve Besleyici",
        icon: "🥥",
        description: "Yağı dengeleyerek cildi besler ve sağlıklı görünüm kazandırır."
    },
    {
        key: "Water Resistance and Longevity",
        label: "Suya Dayanıklılık ve Kalıcılık",
        icon: "💦",
        description: "Ürünün cilt üzerinde uzun süre dayanmasını sağlar."
    },
    {
        key: "Soothing and Anti-Inflammatory Effects",
        label: "Cilt Yatıştırıcı",
        icon: "🍃",
        description: "Cildi sakinleştirir ve iltihaplanmayı azaltır."
    },
    {
        key: "UV Protection",
        label: "Güneş Koruması",
        icon: "☀️",
        description: "Güneşin zararlı ışınlarına karşı cildi korur."
    },
    {
        key: "Shine Enhancement and Appearance Boost",
        label: "Cilt Canlandırıcı",
        icon: "💡",
        description: "Cilde doğal bir parlaklık kazandırır ve sağlıklı görünüm sunar."
    },
    {
        key: "Growth Stimulation and Strengthening",
        label: "Kaş Güçlendirici",
        icon: "💪",
        description: "Kaş ve kirpiklerin güçlenmesini ve uzamasını destekler."
    },
    {
        key: "Hydration, Repair, and Protection",
        label: "Nemlendirme ve Onarım",
        icon: "🩹",
        description: "Cildi derinlemesine nemlendirir, onarır ve korur."
    },
    {
        key: "Antioxidant & Environmental Defense",
        label: "Cilt Hasar Koruma",
        icon: "🛑",
        description: "Cildi güneş, kirli hava ve zararlı maddelerden korur."
    },
    {
        key: "UV Protection & Long-Wear",
        label: "Güneş Koruması ve Kalıcılık",
        icon: "🌞",
        description: "Cildi UV ışınlarından korur ve uzun süreli etki sağlar."
    }
];

export const INGREDIENTS_MAP = {
    hydrating: [
        "Hyaluronic Acid",
        "Aloe Vera",
        "Glycerin",
        "Panthenol (Provitamin B5)",
        "Urea",
        "Caprylyl Glycol",
        "Butylene Glycol",
        "Betaine",
        "Sorbitol",
        "Sodium PCA",
        "Propylene Glycol",
        "Hydroxyethyl Cellulose",
        "Hyaluronic Hydrolyzed Human Hair Keratin",
        "Propylene Glycol Dicocoate",
        "Glycol Stearate",
        "Glycolic Acid"
    ],
    reduces_hair_loss: [
        "Biotin",
        "Caffeine",
        "Saw Palmetto",
        "Niacinamide",
        "Minoxidil",
        "Pyridoxine (Vitamin B6)"
    ],
    anti_dandruff: [
        "Ketoconazole",
        "Zinc Pyrithione",
        "Selenium Sulfide",
        "Ciclopirox Olamine",
        "Piroctone Olamine (Octopirox)",
        "Climbazole",
        "Coal Tar",
        "Salicylic Acid",
        "Sulfur",
        "Ichthyol (Sodium Shale Oil Sulfonate)",
        "Tea Tree Oil",
        "Zinc Carbonate"
    ],
    reduces_frizz: [ // Gel-forming Agents
        "Argan Oil",
        "Dimethicone",
        "Cyclopentasiloxane",
        "Shea Butter",
        "Silicone Copolymers",
        "Quaternium-26",
        "Polyquaternium-37",
        "Behentrimonium Chloride",
        "Quaternium-80",
        "Hydroxypropyl Guar Hydroxypropyltrimonium Chloride",
        "Polyquaternium-11",
        "Quaternium-15",
        "Amodimethicone",
        "Dimethiconol",
        "Guar Hydroxypropyltrimonium Chloride",
        "Hydroxypropyl Methylcellulose",
        "PEG-45M",
        "PPG-9",
    ],
    strengthens_hair: [ // Proteinler, Amino Asitler
        "Keratin",
        "Hydrolyzed Silk Protein",
        "Hydrolyzed Soy Protein",
        "Hydrolyzed Wheat Protein",
        "Hydrolyzed Rice Protein",
        "Hydrolyzed Collagen",
        "Hydrolyzed Milk Protein",
        "Lysine",
        "Methionine",
        "Arginine",
        "Serine",
        "Cystine",
        "Glycine",
        "Alanine",
        "Threonine",
        "Proline",
        "Isoleucine",
        "Leucine",
        "Valine",
        "Histidine",
        "Phenylalanine",
        "Tyrosine",
        "Tryptophan"
    ],
    soothes_scalp: [
        "Aloe Vera",
        "Allantoin",
        "Menthol",
        "Calendula Extract",
        "Chamomile Extract",
        "Beta-Glucan",
        "Zinc Pyrithione",
        "Ketoconazole",
        "Tea Tree Oil",
        "Mentha Piperita (Peppermint) Oil",
        "Mentha Arvensis Leaf Oil",
        "Eucalyptus Globulus Leaf Extract",
        "Rosemary",
        "Slippery Elm",
        "Comfrey Extract",
        "Cucumber Extract"
    ],
    adds_shine: [ // Opacifiers / Pearlescent substances
        "Silk Protein",
        "Argan Oil",
        "Jojoba Oil",
        "Coconut Oil",
        "Castor Oil",
        "Sunflower Oil",
        "Macadamia Oil",
        "Olive Oil",
        "Murumuru Butter",
        "Sweet Almond Oil",
        "Babassu Oil",
        "Grapeseed Oil",
        "Mango Butter",
        "Cocoa Butter",
        "Wheat Germ Oil",
        "Dimethiconol",
        "Hydroxypropyl Methylcellulose",
        "Mica",
        "PEG-45M",
        "PPG-9",
        "Avocado Oil",
        "Persea Gratissima (Avocado) Oil",
        "Persea Gratissima Oil",
        "Vitis Vinifera (Grape) Seed Oil",
    ],
    uv_protection: [
        "Vitamin E",
        "Ethylhexyl Methoxycinnamate",
        "Avobenzone",
        "Titanium Dioxide",
        "Cl 77891",
        "Zinc Oxide",
        "Benzophenone",
        "Benzophenone-4",
        "Octocrylene",
        "Octyl Methoxycinnamate",
    ],
};

// irritating: [
//     "Sodium Lauryl Sulfate (SLS)",
//     "Sodium Laureth Sulfate (SLES)",
//     "Ammonium Lauryl Sulfate",
//     "Ammonium Laureth Sulfate",
//     "Fragrance (Parfum)",
//     "Isopropyl Alcohol",
//     "Denatured Alcohol",
//     "Linalool",
//     "Citronellol",
//     "Synthetic Dyes (FD&C Dyes)",
//     "Sodium Chloride",
//     "Cocamide DEA",
//     "Cocamide MEA",
//     "Cocamide MEA/DEA",
//     "Disodium Laureth Sulfosuccinate",
//     "TEA-Lauryl Sulfate",
//     "Sodium Lauroyl Sarcosinate",
//     "Butylphenyl Methylpropional",
//     "Lilial"
// ],
// hormone_disruptors: [
//     "Methylparaben",
//     "Ethylparaben",
//     "Propylparaben",
//     "Butylparaben",
//     "Isobutylparaben",
//     "Isopropylparaben",
//     "Benzylparaben",
//     "Diethyl Phthalate",
//     "Dibutyl Phthalate",
//     "Dimethyl Phthalate",
//     "Diisononyl Phthalate",
//     "Diisobutyl Phthalate",
//     "Butyl Benzyl Phthalate",
//     "Di(2-ethylhexyl) Phthalate (DEHP)",
//     "Butylphenyl Methylpropional", // banned in eu, same as Lilial
//     "Lilial" // banned in eu
// ],
// irritation: [
//     "Lauric Acid",
//     "Coconut Oil",
//     "Isopropyl Palmitate",
//     "Myristic Acid",
//     "Ethylhexyl Palmitate",
//     "Oleic Acid"
// ],
// carcinogens: [
//     "Formaldehyde",
//     "1,4-Dioxane",
//     "Coal Tar",
//     "DMDM Hydantoin",
//     "Imidazolidinyl Urea",
//     "Diazolidinyl Urea",
//     "Zinc Pyrithione" // banned in EU
// ],
// chemical_load: [
//     "PEG-150 Distearate",
//     "Polysorbate 20",
//     "Polysorbate 80",
//     "Phenoxyethanol",
//     "Dimethicone",
//     "Polyquaternium-10",
//     "Acrylates Copolymer",
//     "Hydroxyethylcellulose",
//     "Cetrimonium Chloride",
//     "Polyquaternium-7",
//     "Polyquaternium-11",
//     "Silicone Quaterniums",
//     "Amodimethicone"
// ]

export const EGZEMA_MAP = {
    eczema_friendly: [
        "Aloe Vera",
        "Panthenol (Provitamin B5)",
        "Glycerin",
        "Hyaluronic Acid",
        "Urea",
        "Allantoin",
        "Beta-Glucan",
        "Calendula Extract",
        "Chamomile Extract",
        "Cucumber Extract",
        "Tea Tree Oil",
        "Zinc Pyrithione",
        "Ketoconazole",
        "Caprylyl Glycol",
        "Sorbitol",
        "Hydroxyethyl Cellulose",
        "Eucalyptus Globulus Leaf Extract",
        "Mentha Piperita (Peppermint) Oil",
        "Mentha Arvensis Leaf Oil",
        "Niacinamide",
        "Oat Extract (Avena Sativa)",
        "Shea Butter",
        "Squalane"
    ],
    eczema_risk: [
        "Sodium Lauryl Sulfate (SLS)",
        "Sodium Laureth Sulfate (SLES)",
        "Ammonium Lauryl Sulfate",
        "Fragrance (Parfum)",
        "Isopropyl Alcohol",
        "Denatured Alcohol",
        "Linalool",
        "Citronellol",
        "Synthetic Dyes (FD&C Dyes)",
        "Sodium Chloride (high concentrations)",
        "Cocamide DEA",
        "Cocamide MEA",
        "Disodium Laureth Sulfosuccinate",
        "Lauric Acid",
        "Myristic Acid",
        "Coconut Oil",
        "Ethylhexyl Palmitate",
        "Oleic Acid",
        "DMDM Hydantoin",
        "Imidazolidinyl Urea",
        "Diazolidinyl Urea",
        "Methylisothiazolinone",
        "Methylchloroisothiazolinone (MCI)",
        "Benzyl Alcohol",
        "Phenoxyethanol",
        "Essential Oils (in high concentrations): Eucalyptus, Citrus, or Lavender oils"
    ]
}

export const SPECIAL_SITUATIONS_MAP = {
    "Pregnant": {
        "high": [
            "Methylparaben", "Ethylparaben", "Propylparaben", "Butylparaben", "Isobutylparaben",
            "Diethyl Phthalate", "Dibutyl Phthalate", "Retinol (Vitamin A)", "Minoxidil", "Coal Tar"
        ],
        "low": [
            "Salicylic Acid", "DMDM Hydantoin", "Imidazolidinyl Urea", "Diazolidinyl Urea",
            "Fragrance (Parfum)", "Benzophenone", "Benzophenone-4", "Octocrylene"
        ]
    },
    "Breastfeeding": {
        "high": [
            "Methylparaben", "Ethylparaben", "Propylparaben", "Butylparaben", "Isobutylparaben",
            "Diethyl Phthalate", "Dibutyl Phthalate", "Retinol (Vitamin A)", "Minoxidil", "Coal Tar"
        ],
        "low": [
            "Salicylic Acid", "DMDM Hydantoin", "Imidazolidinyl Urea", "Diazolidinyl Urea",
            "Fragrance (Parfum)", "Benzophenone", "Benzophenone-4", "Octocrylene"
        ]
    },
    "Babies": {
        "high": [
            "Sodium Lauryl Sulfate (SLS)", "Sodium Laureth Sulfate (SLES)", "Fragrance (Parfum)",
            "DMDM Hydantoin", "Imidazolidinyl Urea", "Diazolidinyl Urea", "Colorants",
            "Salicylic Acid", "Coal Tar", "Phenoxyethanol", "Methylparaben", "Ethylparaben",
            "Propylparaben", "Butylparaben", "Isobutylparaben"
        ],
        "low": [
            "Benzyl Alcohol", "Tea Tree Oil", "Lavender Oil"
        ]
    },
    "Children": { // Under 6
        "high": [
            "Sodium Lauryl Sulfate (SLS)", "Sodium Laureth Sulfate (SLES)", "Fragrance (Parfum)",
            "Colorants", "Salicylic Acid", "Coal Tar", "Methylparaben", "Ethylparaben",
            "Propylparaben", "Butylparaben", "Isobutylparaben"
        ],
        "low": [
            "DMDM Hydantoin", "Imidazolidinyl Urea", "Diazolidinyl Urea", "Phenoxyethanol",
            "Benzyl Alcohol", "Tea Tree Oil", "Lavender Oil"
        ]
    }
}

export const GENDER_MAP = {
    "Men": {
        "Ingredients": [
            "Minoxidil",
            "Saw Palmetto",
            "Caffeine",
            "Salicylic Acid",
            "Tea Tree Oil",
            "Menthol",
            "Coal Tar"
        ],
        "Rationale": {
            "Minoxidil": "Targets androgenetic alopecia (male pattern baldness).",
            "Saw Palmetto": "Blocks DHT to reduce hair loss in men.",
            "Caffeine": "Stimulates blood flow and hair follicle growth.",
            "Salicylic Acid": "Exfoliates oily scalps prone to buildup.",
            "Tea Tree Oil": "Reduces oiliness and scalp inflammation.",
            "Menthol": "Provides a cooling effect and stimulates circulation.",
            "Coal Tar": "Addresses dandruff and seborrheic dermatitis."
        }
    },
    "Women": {
        "Ingredients": [
            "Biotin",
            "Keratin",
            "Niacinamide",
            "Argan Oil",
            "Coconut Oil",
            "Silicones",
            "Hyaluronic Acid"
        ],
        "Rationale": {
            "Biotin": "Promotes overall hair health, especially during hormonal changes.",
            "Keratin": "Strengthens hair and improves texture for damaged hair.",
            "Niacinamide": "Improves scalp circulation and reduces inflammation.",
            "Argan Oil": "Moisturizes dry hair and adds shine.",
            "Coconut Oil": "Deep conditions and prevents breakage.",
            "Silicones": "Adds smoothness and controls frizz.",
            "Hyaluronic Acid": "Hydrates hair and scalp."
        }
    },
    "Unisex": {
        "Ingredients": [
            "Aloe Vera",
            "Panthenol",
            "Glycerin",
            "Betaine",
            "Sorbitol",
            "Chamomile Extract",
            "Zinc Pyrithione",
            "Hydrolyzed Proteins"
        ],
        "Rationale": {
            "Aloe Vera": "Soothes the scalp and hydrates hair.",
            "Panthenol": "Provides moisture and strengthens hair.",
            "Glycerin": "Attracts moisture to keep hair hydrated.",
            "Betaine": "A natural humectant for hydration.",
            "Sorbitol": "Prevents dryness and helps retain moisture.",
            "Chamomile Extract": "Soothes irritated scalps and enhances shine.",
            "Zinc Pyrithione": "Treats dandruff and scalp conditions.",
            "Hydrolyzed Proteins": "Strengthens hair for all types."
        }
    }
}

export const getSafetyClass = (score) => {
    if (score == "1.0" || score == "1.5" || score == "2.0" || score == "2.5") return "ingredient-safe";
    if (score == "3.0" || score == "3.5" || score == "4.0" || score == "4.5" || score == "5.0" || score == "5.5" || score == "6.0" || score == "6.5") return "ingredient-moderate";
    if (score == "7.0" || score == "7.5" || score == "8.0" || score == "8.5" || score == "9.0" || score == "9.5" || score == "10.0") return "ingredient-risky";
    return "ingredient-unknown";
};

// SKIN
export const isSkinCategory = (title) => {
    const skinTitles = [
        "Yüz Temizleyici",
        "Yüz Kremi",
        "Göz Çevresi Bakımı",
        "Maske",
        "Tonik",
        "Peeling",
        "Serum ve Bakım Yağları",
        "Vücut Bakımı",
        "Dudak Kremi",
        "Kaş Kirpik Bakımı",
        "Güneş Koruyucu",
        "Fondöten"
    ];
    return skinTitles.includes(title);
};

export const isWaterBased = (product) => {
    const normalize = (str) => str.toLowerCase();
    if (product.ingredients && product.ingredients.length > 0) {
        if (normalize(product.ingredients[0]) === "aqua") {
            return true;
        }
        if (product.other_links && product.other_links.length > 0) {
            for (const link of product.other_links) {
                if (link.ingredients && link.ingredients.length > 0) {
                    if (normalize(link.ingredients[0]) === "aqua") {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}

export function getScoreStyle(score) {
    if (score > 80) return { backgroundColor: "#27ae60", color: "white" }; // Green (Best)
    if (score > 40) return { backgroundColor: "#f39c12", color: "white" }; // Orange (Medium)
    return { backgroundColor: "#e74c3c", color: "white" }; // Red (Worst)
}
